
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.381 9.524h-.476V5.238c0-.79-.638-1.428-1.429-1.428h-2.38V1.429c0-.79-.639-1.429-1.43-1.429H2.382A2.382 2.382 0 000 2.381v16.19C0 19.361.638 20 1.429 20h19.047c.79 0 1.429-.638 1.429-1.429v-4.285h.476c.79 0 1.428-.638 1.428-1.429v-1.905c0-.79-.638-1.428-1.428-1.428zm-20-8.572h14.286c.266 0 .476.21.476.477v2.38H2.38c-.79 0-1.429-.638-1.429-1.428 0-.79.639-1.429 1.429-1.429zm18.571 17.62c0 .266-.21.476-.476.476H1.43a.472.472 0 01-.477-.477V4.276c.4.295.896.486 1.429.486h18.095c.267 0 .476.21.476.476v4.286h-4.285c-.79 0-1.429.638-1.429 1.428v1.905c0 .79.638 1.429 1.429 1.429h4.285v4.285zm1.905-5.715c0 .267-.21.476-.476.476h-5.714a.472.472 0 01-.477-.476v-1.905c0-.266.21-.476.477-.476h5.714c.267 0 .476.21.476.476v1.905z","fill":"#fff"}}),_c('path',{attrs:{"d":"M2.381 2.857h13.333c.267 0 .476-.21.476-.476a.472.472 0 00-.476-.476H2.381a.472.472 0 00-.476.476c0 .267.21.476.476.476z","fill":"#fff"}})])
          )
        }
      }
    